import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class Municipality {

  private baseUrl = `${environment.apiUrl}/catalog/municipality`;

  constructor(private http: HttpClient) {}

  getMunicipalityByDepartament(departamentId: number) {
    return this.http.get<any[]>(
      `${this.baseUrl}/${departamentId}`
    );
  }
}
